import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import "jquery-serializejson";
import Page from "webPage/Page";
import Track from "webPage/Track";
import {handleHubspotForm} from "./util/hubspot";
import {handleNavigation} from "./util/Navigation";
import handleAccordions from "./util/handleAccordions";
import StickySection from "./util/StickySection";

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    let $heroBanner = $('.js-hero-banner');

    if($heroBanner.length > 0) {
        let $item = $heroBanner.find('.js-banner-item');
        let count = $item.length;
        let current = 0;

        function showItem(index) {
            $item.removeClass('icon-content--active');
            $item.eq(index).addClass('icon-content--active');
        }

        setTimeout(function() {
            showItem(current);
            setInterval(function() {
                current++;
                if(current >= count) {
                    current = 0;
                }
                showItem(current);
            }, 3500);
        });
    }

    Page.init();

    $(".js-hubspot-form").each(function () {
        handleHubspotForm($(this));
    });

    $('.js-sticky-section').each(function () {
        new StickySection($(this));
    });

    handleNavigation();
    handleAccordions();

    let $articles_track = $(".js-articles-track-wrap");
    if ($articles_track.length > 0) {
        new Track($articles_track, {
            classes: {
                block: "slider",
            },
        });
    }

    $("body").on("click", ".js-show-share-icons", function () {
            $(this).toggleClass("share--active");
            return false;
        }).on("click", ".js-footer-toggle", function () {
            $(this).parent().toggleClass("footer-navigations__navigation--active");
            return false;
        }).on("click", ".js-scroll-to", function () {
            let id = $(this).attr("href");
            let scrollTop = $(id).offset().top;
            $("html, body").animate({scrollTop: scrollTop - 70}, 300);
            return false;
        }).on('click', '.js-toggle-footer-nav', function(){
            $(this).toggleClass('active').parents('.footer-columns__column').find('.js-footer-nav').slideToggle();
        });
});

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
